import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Breadcrumbs, Button, Collapsible, Input, ScannerCode, Select, SelectResource } from '../../../../components/UI/ComponentsUI';
import ChangeLocationService from '../../../../services/ChangeLocationService';
import { getVision } from '../../../../services/auth';
import { ENUMS, VISIONS } from '../../../../utils/constants';
import { onRowChange, onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';
import { translate, showMessageToastCustom, isNullOrEmpty } from '../../../../utils/util';
import SecurityService from '../../../../services/SecurityService';

const ChangeLocationTwoSteps = (props) => {
    const getDefaultResourceChangeLocation = () => {
        if (getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) {
            var resourceDefault = props.resources.find(i => i.name === '1000');
            return resourceDefault?.resourceId;
        }
        return props.user.resource || ''
    }

    const [locationParts, setLocationParts] = useState([]);
    const [change, setChange] = useState({
        print: ENUMS.ePrintTypes.Logistics.value,
        resourceId: getDefaultResourceChangeLocation(),
    });

    useEffect(() => {
        if (props.twoSteps) {
            props.twoSteps.forEach((element) => {
                element.barCode = VISIONS.Jeep && !isNullOrEmpty(element.cimPallet)
                    ? element.cimPallet : element.cim;
                element.location = element.originLocation
            })
            setLocationParts(props.twoSteps);
        }
        // eslint-disable-next-line
    }, [props.twoSteps]);

    const onChange = (event) => {
        onValueChange(event, change, setChange);
    };

    const setResource = () => {
        if (change.print === ENUMS.ePrintTypes.Click.value && !isNullOrEmpty(props.user?.resourceObj?.clickResourceName)) {
            return props.user?.resourceObj?.clickResourceName;
        }

        return props.user?.resourceObj?.name;
    }

    const validateResource = () => {
        if (!props.user?.resourceObj || !props.user?.resourceObj?.resourceId) {
            showMessageToastCustom(translate('warning', 'general'), translate('select-resource', 'validations'), 3000, 'mdi mdi-alert-circle-outline red-text');
            return false;
        }

        return true;
    }

    const onConfirm = () => {
        if (validateInputsRequired("formLocation") && validateResource()) {
            let dataLocation = locationParts.filter(f => f.location !== f.originLocation).map(element => {
                return {
                    ...element,
                    ...change,
                    twoSteps: false,
                    printer: props.user?.printer,
                    resource: setResource(),
                }
            });


            if (dataLocation.length > 0) {
                props.sendChangeLocation(dataLocation, (response) => {
                    if (response?.length > 0) {
                        response.forEach((element) => {
                            if (element.success) {
                                showMessageToastCustom(translate('general.info'), "Locação realizada com sucesso", 5000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                            } else {
                                showMessageToastCustom(translate('warning', 'general'), element.message, 5000, 'mdi mdi-alert-circle-outline red-text');
                            }
                        })
                    }
                    sendPrinterLocation(locationParts.filter(f => f.location === f.originLocation))
                })
            } else {
                sendPrinterLocation(locationParts.filter(f => f.location === f.originLocation))
            }
        }
    }

    const sendPrinterLocation = (data) => {
        let dataLocation = data.map(element => {
            return {
                ...element,
                ...change,
                printer: props.user?.printer,
                resource: setResource(),
            }
        });
        if (dataLocation.length > 0) {
            reprintLocation(dataLocation)
        }
    }

    const reprintLocation = (dataLocations) => {
        var item = dataLocations[0];
        props.reprintLabel(item, () => {
            dataLocations = dataLocations?.filter((i) => i.id !== item.id);
            if (dataLocations.length > 0) {
                reprintLocation(dataLocations);
            }
        });
    }


    const onChangeRow = (evt) => {
        onRowChange(evt, locationParts, setLocationParts)
    }

    const scannerBarCode = (value, data) => {
        var item = locationParts.find((f) => f.id === data.id);

        if (item) {
            item.barCode = value;
            setLocationParts([...locationParts])
        }
        setChange({ ...change });
    };


    const renderMassive = () => {
        return locationParts.map((item, index) => (
            <div className='row'>
                <div className='no-padding col s10'>
                    <Collapsible
                        key={`${item.id}`}
                        simple="true"
                        close="true"
                        header={`${item.cim} ${!isNullOrEmpty(item.cimPallet) && `(${item.cimPallet})`} - ${item.originLocation} - ${item.partNumberCode} - ${item.quantity}`}
                        body={
                            <div className='row'>
                                <div className="input-field no-padding col s10">
                                    <ScannerCode onScanner={(value) => scannerBarCode(value, item)} />
                                    <Input
                                        label="Locação"
                                        id={`${index}.location`}
                                        name={`${index}.location`}
                                        defaultValue={item.location}
                                        type="text"
                                        onChange={onChangeRow}
                                    />
                                </div>
                                <div className="input-field no-padding  col s5">
                                    <Input
                                        label="MDR"
                                        id={`${index}.mdr`}
                                        name={`${index}.mdr`}
                                        type="text"
                                        defaultValue={""}
                                        onChange={onChangeRow}
                                    />
                                </div>
                                <div className="input-field no-padding  col s5">
                                    <Input
                                        label="Qtd Peças por Caixa"
                                        id={`${index}.cimQuantity`}
                                        name={`${index}.cimQuantity`}
                                        defaultValue={""}
                                        type="text"
                                        onChange={onChangeRow}
                                    />
                                </div>
                            </div>
                        }
                    />
                </div>
                <span className="col s2" style={{ paddingTop: '10px' }}>
                    <i style={{ cursor: 'pointer' }} onClick={() => sendPrinterLocation([item])} className="mdi mdi-36px mdi-printer"></i>
                </span>
            </div>
        ));
    }

    return (
        <div>
            <Breadcrumbs id="changeLocation" title={{ icon: "mdi mdi-clipboard-check-outline", label: "Troca de locação" }} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container" style={{ width: '96%' }}>
                    <div className='card'>
                        <div className="card-content" style={{ padding: '3px', paddingBlockEnd: '1px' }}>
                            <div id="formLocation" style={{ marginBottom: '0px' }}>
                                <div className='row'>
                                    <div className="input-field no-padding  col s12">
                                        <Select
                                            required
                                            id="print"
                                            name="print"
                                            display="name"
                                            label={translate('print-type', 'physical-confirmation')}
                                            placeHolder={translate('choose-one-option', 'general')}
                                            data={[
                                                { id: ENUMS.ePrintTypes.Logistics.value, text: translate(ENUMS.ePrintTypes.Logistics.text, 'physical-confirmation') },
                                                { id: ENUMS.ePrintTypes.Click.value, text: translate(ENUMS.ePrintTypes.Click.text, 'physical-confirmation') },
                                                { id: ENUMS.ePrintTypes.NotPrint.value, text: translate(ENUMS.ePrintTypes.NotPrint.text, 'physical-confirmation') },
                                            ]}
                                            change={(e) => {
                                                props.setPrintSelect(e.target.value);
                                                onChange(e);
                                            }}
                                            defaultValue={change.print}
                                        />
                                    </div>
                                    <div className="input-field no-padding  col s12">
                                        <SelectResource
                                            required
                                            loadConfigLaser={getVision() === VISIONS.Jeep}
                                            id="resourceId"
                                            name="resourceId"
                                            value={change.resourceId}
                                            onChange={onChange}
                                        />
                                    </div>
                                </div>
                                {
                                    locationParts?.length > 0 &&
                                    <div style={{ marginTop: '10px' }}>
                                        {renderMassive()}
                                    </div>
                                }
                            </div>
                            <div className="row">
                                <Button onClick={() => props.history.goBack(-2)} text={translate('cancel', 'general')} secundary="true" />
                                <Button onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        resources: state.logisticsResourceReducer.list,
        user: state.userReducer.user,
        config: state.configReducer.config,
        printSelect: state.physicalConfirmationReducer.printSelect,
        twoSteps: state.locationReducer.twoSteps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        sendChangeLocation: (locations, callback) => {
            dispatch(ChangeLocationService.changeLocationList(locations, callback));
        },
        setPrintSelect: (printSelect) => {
            dispatch(ChangeLocationService.setPrintSelect(printSelect));
        },
        reprintLabel: (data, callback) => {
            dispatch(ChangeLocationService.reprintLabel(data, callback))
        },
        setResource: (resource) => {
            dispatch(SecurityService.setResource(resource));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ChangeLocationTwoSteps));